import { Navigate, useLocation, useResolvedPath } from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "../services/wp.auth.service";

const RequireAuth = ({
	children,
	requireRole,
	allowNonAuth
}) => {
	const { user } = useAuth();
	const location = useLocation();
	const path = useResolvedPath();

	if (!user) {

		/*
		 * Redirect them to the /login page, but save the current location they were
		 * trying to go to when they were redirected. This allows us to send them
		 * along to that page after they login, which is a nicer user experience
		 * than dropping them off on the home page.
		 */

		return allowNonAuth
			? children
			: (
				<Navigate
					replace
					state={{
						from: location
					}}
					to="/login"
				/>
			);
	} else if (
		requireRole !== "" &&
		user.roles.indexOf(requireRole) === -1
	) {
		if (
			requireRole !== "facilitator" ||
			// eslint-disable-next-line no-extra-parens
			(requireRole === "facilitator" && !user.facilitatorId)
		) {
			return (
				<Navigate
					replace
					to="/"
				/>
			);
		}

	} else if (
		!user.emailVerified &&
		["administrator", "staff", "facilitator"].indexOf(user.roles[0]) === -1 &&
		path.pathname.search("/account/register-success") !== 0
	) {
		return (
			<Navigate
				replace
				to="/account/register-success"
			/>
		);
	}

	return children;
};

RequireAuth.propTypes = {
	allowNonAuth: PropTypes.bool,
	children: PropTypes.node.isRequired,
	requireRole: PropTypes.string
};

RequireAuth.defaultProps = {
	allowNonAuth: false,
	requireRole: ""
};

export default RequireAuth;
